import Vuex, { Store } from 'vuex';
import { workOrderActions } from '@/store/work-order/workOrder.actions';
import { IWorkOrderState } from '@/store/work-order/workOrder.state';
import { workOrderMutations } from '@/store/work-order/workOrder.mutations';

export let workOrderStore: Store<IWorkOrderState>;

export function initializeWorkOrderStore() {
    workOrderStore = new Vuex.Store<IWorkOrderState>({
        // Keys must be declared here (even as undefined): Vue 2 only observes
        // properties that exist on the initial state, so an undeclared key
        // assigned later by a mutation is NOT reactive — bindings and computeds
        // on upsertWorkOrder silently freeze.
        state: {
            workOrderUsers: [],
            workOrderTypes: [],
            workOrderChecklists: [],
            selectedClient: null,
            upsertWorkOrder: undefined,
            isCachedUpsertWorkOrder: undefined,
        },
        actions: workOrderActions,
        mutations: workOrderMutations,
    });
    return workOrderStore;
}
